<template>
    <div>
        <h4 v-if="canAdd">
            {{ title }}
            <a v-if="editable" href class="uk-icon-button uk-button-mini uk-icon-plus" @click.prevent="add_contact_method(type)"></a>
        </h4>
        <ul class="uk-list uk-list-space">
            <li v-for="contact in records" :key="contact.id">
                <form-link-input
                    :record="contact"
                    :editable="editable"
                    @input="save(contact, ...arguments)"
                />
            </li>
        </ul>
    </div>
</template>

<script type="text/javascript">
import handles_saving from "../mixins/HandlesSaving"
import notifies from "../mixins/Notifies"

import FormLinkInput from "./FormLinkInput"

export default {
    components: {
        FormLinkInput
    },
    mixins: [handles_saving, notifies],
    methods: {
        save (record, value, field) {
            let data = { [field]: value }
            if(field === "scope") data = value
            this.$store.dispatch("RECORD_SAVE", {
                entity: this.entity,
                id: record.id,
                data
            }).catch(this.receive_error)
        },
        add_contact_method (method) {
            this.$store.dispatch("CREATE_RECORD", {
                entity: "contact_method",
                data: {
                    owner_id: this.ownerId,
                    owner_type: this.ownerType.replace(/\./g, "\\"),
                    method,
                    scope: this.$root.constants.contact_method_scopes.SCOPE_WORK,
                    address: ""
                }
            }).then(() => {

            }).catch(error => {
                this.$error(error.message)
            })
        }
    },
    props: {
        ownerType: {
            type: String,
            required: true
        },
        ownerId: {
            type: Number,
            required: true
        },
        editable: {
            type: Boolean,
            default: true
        },
        canAdd: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: ""
        },
        type: {
            type: String,
            required: true
        },
        records: {
            type: Array,
            default () {
                return []
            }
        }
    },
    data () {
        return {
            record_id: 0,
            entity: "contact_method"
        }
    }
}
</script>
